import { fetchWarehouseLocationList } from '#/api/system/warehouseLocation/fetchList';
import { fetchWarehouseLocationDetail } from '#/api/system/warehouseLocation/fetchDetail';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

export function mapWarehouseLocationRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: row.code ? `${row.code} - ${row.name}` : (row.name || row.id),
  }));
}

/**
 * 列表／picker 儲位 async multi filter。
 * `parentFilters.warehouseId` 可選：有則 narrowing；無則全庫搜尋。
 */
export async function searchWarehouseLocationFilterOptions({
  keyword,
  parentFilters,
} = {}) {
  const filters = {};
  if (parentFilters?.warehouseId != null && parentFilters.warehouseId !== '') {
    filters.warehouseId = parentFilters.warehouseId;
  }

  const result = await fetchWarehouseLocationList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    filters,
    sort: [],
  });

  return mapWarehouseLocationRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 locationId 但 label cache 空時，依 id 補 `code - name`。
 * @returns {Promise<boolean>} 是否有寫入新 label
 */
export async function hydrateWarehouseLocationFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchWarehouseLocationDetail(id);
      const row = result?.data;
      if (!row) {
        return;
      }

      const label = row.code ? `${row.code} - ${row.name}` : (row.name || String(id));
      labelCache.set(String(id), label);
    } catch {
      // unresolved → ListFilterStatus 顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}
